import { transformFinancialResultToTableData } from './transformFinancialResultToTableData';

export { transformFinancialResultToTableData };
